import BlogPage from "./components/storyblok/BlogPage"
import BlogPost from "./components/storyblok/BlogPost"
import PageRenderer from "./components/storyblok/concierge/PageRenderer"
import Hero from "./components/storyblok/concierge/Hero"
import AreYouACoach from "./components/storyblok/concierge/AreYouACoach"
import Tiers from "./components/storyblok/concierge/Tiers"
import TierItem from "./components/storyblok/concierge/TierItem"
import WhatYoullGet from "./components/storyblok/concierge/WhatYoullGet"
import GetItem from "./components/storyblok/concierge/GetItem"
import ValueProps from "./components/storyblok/concierge/ValueProps"
import ValueItem from "./components/storyblok/concierge/ValueItem"
import Testimonials from "./components/storyblok/concierge/Testimonials"
import TestimonialItem from "./components/storyblok/concierge/TestimonialItem"
import WhyConcierge from "./components/storyblok/concierge/WhyConcierge"
import VideoMessage from "./components/storyblok/concierge/VideoMessage"
import FAQAccordion from "./components/storyblok/concierge/FAQAccordion"
import FAQItem from "./components/storyblok/concierge/FAQItem"
import CoachFeature from "./components/storyblok/concierge/CoachFeature"

export const components = {
  blog_page: BlogPage,
  blog_post: BlogPost,
  page: PageRenderer,
  Hero,
  AreYouACoach,
  Tiers,
  TierItem,
  WhatYoullGet,
  GetItem,
  ValueProps,
  ValueItem,
  Testimonials,
  TestimonialItem,
  WhyConcierge,
  VideoMessage,
  FAQAccordion,
  FAQItem,
  CoachFeature,
}
